import { Link } from 'react-router-dom';
import {
  GqlArticlesOfAssoc,
  GqlAuthorizationGroup,
  type GqlMeeting,
  GqlMeetingKind,
  GqlShareIssue,
  GqlWarrantProgram,
  GqlWarrantProgramKind,
} from '../graphql/base-types.graphql';

export const meetingsLink = (kind: GqlMeetingKind) => {
  return `/board-portal/${kind === GqlMeetingKind.BoardMeeting ? 'board-meetings' : 'shareholders-meetings'}`;
};

export const meetingLink = (meeting: Pick<GqlMeeting, 'id' | 'kind'>) => {
  return `${meetingsLink(meeting.kind)}/${meeting.id}`;
};

export const meetingLinkShow = (meeting: Pick<GqlMeeting, 'id' | 'kind' | 'companyId'>, full?: boolean) => {
  const url = `${meetingLink(meeting)}/show`;
  if (full) {
    return `/company/${meeting.companyId}${url}`;
  }
  return url;
};

export const meetingLinkShowProtocol = (meeting: Pick<GqlMeeting, 'id' | 'kind' | 'companyId'>, full?: boolean) => {
  return `${meetingLinkShow(meeting, full)}/protocol`;
};

export const meetingLinkEdit = (meeting: Pick<GqlMeeting, 'id' | 'kind' | 'companyId'>, full?: boolean) => {
  const url = `${meetingLink(meeting)}/edit`;
  if (full) {
    return `/company/${meeting.companyId}${url}`;
  }
  return url;
};

export const MeetingLink = {
  Show: {
    Protocol: (
      meeting: Pick<GqlMeeting, 'id' | 'kind' | 'companyId'>,
      ngNavigateByUrl?: (to: string) => Promise<void>,
    ) => {
      return (
        <Link
          onClick={ngNavigateByUrl ? () => ngNavigateByUrl?.(meetingLinkShowProtocol(meeting)) : undefined}
          to={meetingLinkShowProtocol(meeting, true)}
        ></Link>
      );
    },
  },
};

export const wpsLink = (kind: GqlWarrantProgramKind) => {
  switch (kind) {
    case GqlWarrantProgramKind.Employee: {
      return `/stock-options/employee-options`;
    }
    case GqlWarrantProgramKind.Warrant: {
      return `/stock-options/warrant-programs`;
    }
    case GqlWarrantProgramKind.Wise: {
      return `/investments/wise-options`;
    }
    case GqlWarrantProgramKind.Nice: {
      return `/investments/nice-options`;
    }
  }
};

const wpLink = (wp: Pick<GqlWarrantProgram, 'id' | 'warrantKind'>) => {
  return `${wpsLink(wp.warrantKind)}/${wp.id}`;
};

export const wpEditLink = (wp: Pick<GqlWarrantProgram, 'id' | 'warrantKind' | 'usesStepper'>) => {
  return `${wpLink(wp)}/${!wp.usesStepper && wp.warrantKind === GqlWarrantProgramKind.Warrant ? 'edit-snr-based' : 'edit'}`;
};

export const wpEditOptionsSubsLink = (wp: Pick<GqlWarrantProgram, 'id' | 'warrantKind' | 'usesStepper'>) => {
  return `${wpEditLink(wp)}/main-step-options-subscriptions`;
};

export const wpEditOptionsSharesSubsLink = (wp: Pick<GqlWarrantProgram, 'id' | 'warrantKind' | 'usesStepper'>) => {
  return `${wpEditLink(wp)}/main-options-shares-subscription`;
};

export const wpEditDocumentsLink = (wp: Pick<GqlWarrantProgram, 'id' | 'warrantKind' | 'usesStepper'>) => {
  return `${wpEditLink(wp)}/main-step-options-documents`;
};

export const wpEditStepProgramLink = (wp: Pick<GqlWarrantProgram, 'id' | 'warrantKind' | 'usesStepper'>) => {
  return `${wpEditLink(wp)}/main-step-program`;
};

export const wpEditLanguageLink = (wp: Pick<GqlWarrantProgram, 'id' | 'warrantKind' | 'usesStepper'>) => {
  return `${wpEditStepProgramLink(wp)}/language`;
};

export const wpEditDecisionLink = (wp: Pick<GqlWarrantProgram, 'id' | 'warrantKind' | 'usesStepper'>) => {
  return `${wpEditStepProgramLink(wp)}/decision`;
};

export const wpEditDecisionLinkOld = (wp: Pick<GqlWarrantProgram, 'id' | 'warrantKind' | 'usesStepper'>) => {
  return `${wpEditLink(wp)}/main-step-decision`;
};

export const sisLink = () => {
  return '/investments/share-issues';
};

export const siLink = (si: Pick<GqlShareIssue, 'id'>) => {
  return `${sisLink()}/${si.id}`;
};

export const siShowDocumentsLink = (si: Pick<GqlShareIssue, 'id'>) => {
  return `${siLink(si)}/show/documents`;
};

export const siEditLink = (si: Pick<GqlShareIssue, 'id'>) => {
  return `${siLink(si)}/edit`;
};

export const authorizationGroupsLink = () => {
  return '/board-portal/authorization-groups';
};

export const authorizationGroupLink = (ag: Pick<GqlAuthorizationGroup, 'id'>) => {
  return `${authorizationGroupsLink()}/${ag.id}`;
};

export const authorizationGroupLinkEdit = (ag: Pick<GqlAuthorizationGroup, 'id'>) => {
  return `${authorizationGroupLink(ag)}/edit`;
};

export const articlesOfAssocsLink = () => {
  return '/board-portal/articles-of-assocs';
};

export const articlesOfAssocLink = (aoa: Pick<GqlArticlesOfAssoc, 'id'>) => {
  return `${articlesOfAssocsLink()}/${aoa.id}`;
};

export const articlesOfAssocLinkEdit = (aoa: Pick<GqlArticlesOfAssoc, 'id'>) => {
  return `${articlesOfAssocLink(aoa)}/edit`;
};
